<template>
  <div class="home h-100">
    <NavbarMain />
    <div class="row h-100 m-0 mb-5 pb-5">
      <div class="col-xl-auto h-100 p-0 col-sm-12 h-sm-auto">
        <NavbarAdmin />
      </div>
      <div class="col mb-5">
        <h1 class="text-center py-4">Transacciones</h1>
        <div class="container">
          <table class="table">
            <thead class="thead-dark text-center">
              <tr>
                <th scope="col">Usuario</th>
                <th scope="col">Sacoin</th>
                <th scope="col" class="d-none d-md-table-cell">Fecha</th>
                <th class="d-none d-md-table-cell" scope="col">Tipo</th>
                <th scope="col">Estado</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody class="text-center" v-if="transactions.length">
              <tr v-for="transaction in transactions" :key="transaction._id">
                <td scope="col">{{ transaction.user.username }}</td>
                <td scope="col">SC${{ transaction.payment.toFixed(2) }}</td>
                <td scope="col" class="d-none d-md-table-cell">
                  {{
                    transaction.creationDate
                      .replace(/T/, " ")
                      .replace(/\..+/, "")
                  }}
                </td>
                <td class="d-none d-md-table-cell">
                  <span v-if="transaction.name == 'APPLE_TRANSACTION'"
                    >Transferencia a Sistema Apple</span
                  >
                  <span v-if="transaction.name == 'DEFAULT_RETIRE'"
                    >Retiro de saldo</span
                  >
                </td>
                <td class="d-flex align-items-center">
                  <span
                    v-if="transaction.state == 0 || !transaction.state"
                    class="material-icons text-warning"
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title="en proceso de retiro"
                  >
                    history
                  </span>
                  <span
                    v-if="transaction.state == 1"
                    class="material-icons text-success"
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title="retiro aceptado"
                  >
                    check_circle_outline
                  </span>
                  <span
                    v-if="transaction.state == 2"
                    class="material-icons text-danger"
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title="retiro denegado"
                  >
                    highlight_off
                  </span>

                  <span
                    class="d-none d-lg-block pl-1"
                    v-if="transaction.state == 0 || !transaction.state"
                    >En proceso de retiro</span
                  >
                  <span
                    class="d-none d-lg-block pl-1"
                    v-if="transaction.state == 1"
                    >Retiro aceptado</span
                  >
                  <span
                    class="d-none d-lg-block pl-1"
                    v-if="transaction.state == 2"
                    >Retiro denegado</span
                  >
                </td>
                <td>
                  <span
                    class="material-icons text-info cursor-pointer"
                    @click="handleModalTransaction(transaction._id)"
                    >settings</span
                  >
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="8" class="text-center">
                  No hay ninguna venta que cumpla con el filtro
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <ModalEditTransaction
      :visible="modalEditTransaction.visible"
      :data="modalEditTransaction.data"
      v-on:close="modalEditTransactionClose"
    />
  </div>
</template>

<script>
import NavbarMain from "@/components/NavbarMain.vue";
import NavbarAdmin from "@/components/NavbarAdmin.vue";
import ModalEditTransaction from "@/components/modals/ModalEditTransaction.vue";
import Configs from "@/configs/configs";
import Api from "@/tools/Api2";
import { mapState } from "vuex";

export default {
  name: "AdminTransactions",
  data() {
    return {
      transactions: [],
      url: Configs.API.BASE,
      modalEditTransaction: {
        visible: false,
        data: {
          _id: "0",
          creationDate: "",
          info: "",
          name: "DEFAULT_TRANSACTION",
          payment: 0,
          state: 0,
          props: {},
          user: {
            username: "",
          },
        },
      },
    };
  },
  computed: {
    ...mapState(["auth"]),
  },
  methods: {
    modalEditTransactionClose() {
      this.modalEditTransaction.visible = false;
    },
    handleModalTransaction(id) {
      this.modalEditTransaction.data = this.transactions.find(
        (e) => e._id == id
      );
      this.modalEditTransaction.visible = true;
    },
  },
  components: {
    NavbarMain,
    NavbarAdmin,
    ModalEditTransaction,
  },
  created: function () {
    Api("transaction")
      .get()
      .then((res) => {
        this.transactions = res.transactions;
      });
  },
};
</script>